"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var card_1 = require("./card");
exports.CardService = card_1.CardService;



//////////////////
// WEBPACK FOOTER
// ./scripts/apps/card/services/index.js
// module id = 459
// module chunks = 0